import { Component, Input, OnChanges } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import * as _ from 'lodash';

import { ValuePair } from '../../interfaces/ValuePair';
import { SelectedDeselected } from '../../interfaces/SelectedDeselected';
import { TOOLTIP_COLOR } from '../tooltip/TooltipColor.enum';
import { TOOLTIP_POSITION } from '../tooltip/TooltipPosition.enum';

@Component({
  selector: 'ls-switch-table',
  templateUrl: 'switch-table.component.html',
  styleUrls: ['./switch-table.component.scss']
})
export class SwitchTableComponent implements ControlValueAccessor, OnChanges {
  @Input()
  public items: Array<ValuePair>;
  @Input()
  public legendItems: Array<ValuePair>;
  @Input()
  public titles: SelectedDeselected;

  public tooltipColor: string = TOOLTIP_COLOR.LIGHT;
  public tooltipPosition: string = TOOLTIP_POSITION.LEFT;

  public selectedValues: Array<any> = [];
  public SELECTED = 'selected';
  public DESELECTED = 'deselected';
  private defaultClass = 'right__items--optional';

  public writeValue(list: any): void {
    if (Array.isArray(list)) {
      this.selectedValues = list;
    } else if (list) {
      throw Error('ls-switch-table only accepts arrays as data');
    }
  }

  public getData(
    list: Array<ValuePair>,
    selectedValues: Array<any>,
    containingSelectedValues: boolean
  ): Array<any> {
    return list.filter(
      (item: any) =>
        (selectedValues.indexOf(item.value) !== -1) === containingSelectedValues
    );
  }

  public registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  public registerOnTouched(): void {
    return;
  }

  public ngOnChanges(changes: any): void {
    if (changes.items.currentValue) {
      changes.items.currentValue.forEach((item: ValuePair) => {
        if (item.name === this.SELECTED) {
          this.selectedValues.push(item.value);
        }
      });
    }
  }

  public moveItem(item: ValuePair, position: string): void {
    const itemValue: any = item.value;
    if (!itemValue.disabled) {
      if (position === this.DESELECTED) {
        itemValue.class = itemValue.class || this.defaultClass;
        this.selectedValues.push(itemValue);
      } else if (position === this.SELECTED) {
        this.selectedValues.splice(this.selectedValues.indexOf(itemValue), 1);
      }
      this.propagateChange(this.selectedValues);
    }
  }

  public moveItems(position: string): void {
    if (position === this.DESELECTED) {
      this.items.forEach((item: any) => {
        if (!item.value.disabled) {
          item.value.class = item.value.class || this.defaultClass;
          this.selectedValues.push(item.value);
        }
      });
    } else if (position === this.SELECTED) {
      const tempSelectedValues: Array<any> = _.clone(this.selectedValues);
      this.selectedValues = [];
      tempSelectedValues.forEach((item: any) => {
        if (item.disabled) {
          item.class = item.class || this.defaultClass;
          this.selectedValues.push(item);
        }
      });
    }
    this.propagateChange(this.selectedValues);
  }

  private propagateChange = (_change: any): void => {
    console.log(_change);
  };
}
